<template>
    <div v-show="editShow">
        <div class="container">
            <el-row :gutter="20">
                <div class="clearfix">
                    <div class="crumbs">
                        <i class="el-icon-back"></i>
                        <el-button type="text" @click="goBack">返回</el-button>
                    </div>
                    <div class="btn-save">
                        <el-button type="primary" @click="saveClick('formData')"
                        >保存
                        </el-button
                        >
                    </div>
                </div>
                <div class="form-box">
                    <el-form
                            :model="formData"
                            :rules="rules"
                            ref="formData"
                            label-width="120px"
                            class="eidt-el-form"
                    >
                        <el-form-item label="酒店" prop="projectHotelId">
                            <el-select
                                    v-model="formData.projectHotelId"
                                    placeholder="请选择酒店"
                            >
                                <el-option
                                        v-for="(type, index) in projectHotel"
                                        :label="type.name"
                                        :key="index"
                                        :value="type.projectHotelId"
                                >
                                    <div @click="changeHotel(type)">{{ type.name }}</div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="类型" prop="projectHotelId">
                            <el-select
                                    v-model="formData.projectRoomTypeId"
                                    placeholder="请选择酒店"
                            >
                                <el-option
                                        v-for="(type, index) in projectRoomType"
                                        :label="type.name"
                                        :key="index"
                                        :value="type.projectRoomTypeId"
                                >
                                    <div @click="getChangeType(type)">{{ type.name }}</div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="房间号" prop="roomNo">
                            <el-input v-model="formData.roomNo"></el-input>
                        </el-form-item>
                        <el-form-item label="姓名1" prop="name">
                            <el-input readonly v-model="formData.name"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证1" prop="idCard">
                            <el-input readonly v-model="formData.idCard"></el-input>
                        </el-form-item>
                        <el-form-item label="姓名2" prop="name1">
                            <el-input readonly v-model="formData.name1"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证2" prop="idCard1">
                            <el-input readonly v-model="formData.idCard1"></el-input>
                        </el-form-item>
                        <el-form-item label="禁用/启用" prop="disabled">
                            <el-radio-group v-model="formData.disabled">
                                <el-radio :label="true">禁用</el-radio>
                                <el-radio :label="false">启用</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="是否入住" prop="allocation">
                            <el-radio-group v-model="formData.allocation" disabled>
                                <el-radio :label="true">已入住</el-radio>
                                <el-radio :label="false">未入住</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                </div>
            </el-row>
        </div>
    </div>
</template>

<script>
    import bus from "../common/bus";

    export default {
        name: "edit_project_room",
        data() {
            return {
                rules: {
                    roomNo: [{required: true, message: "请填写房间号", trigger: "blur"}],
                    projectHotelId: [
                        {required: true, message: "请选择酒店", trigger: "blur"},
                    ],
                    projectRoomTypeId: [
                        {required: true, message: "请选择房间类型", trigger: "blur"},
                    ],
                },
                formData: {
                    name: "",
                    name1: "",
                    idCard1: "",
                    idCard: "",
                    type: "",
                    roomNo: "",
                    personal: 0,
                    disabled: false,
                    allocation: false,
                    projectHotelId: null,
                    projectRoomTypeId: null,
                    projectId: localStorage.getItem("project_Id"),
                },
                projectHotelId: null,
                admin: "",
                projectHotel: [],
                projectRoomType: [],
                project_Id: localStorage.getItem("project_Id"),
            };
        },
        props: {
            editShow: {
                type: Boolean,
                default: false,
            },
            arrarList: {
                type: Array,
                default() {
                    return [];
                },
            },
            editData: {
                type: Object,
            },
        },
        watch: {
            editData: function () {
                const item = this.editData;
                if (item) {
                    this.formData = item;
                    this.projectRoomId = item.projectRoomId;
                    this.projectHotelId = item.projectHotelId;
                    this.getProjectRoomType();
                }
            },
        },
        created() {
            bus.$on("getPTypeId", (message) => {
                this.projectHotelId = message;
            });
            this.getProjectHotel();
        },
        methods: {
            getProjectHotel() {
                this.$axios.get("/ProjectHotel/Project/" + this.project_Id).then((res) => {
                    if (res.data.hasError == false) {
                        this.projectHotel = [...res.data.data];
                        this.getProjectRoomType();
                    }
                });
            },
            getProjectRoomType() {
                if (!this.projectHotelId) {
                    return
                }
                this.$axios.get("/ProjectRoomType/Hotel/" + this.projectHotelId).then((res) => {
                    if (res.data.hasError == false) {
                        this.projectRoomType = [...res.data.data];
                    }
                });
            },
            changeHotel(type) {
                this.projectHotelId = type.projectHotelId;
                this.formData.projectRoomTypeId = null;
                this.getProjectRoomType();
            },
            getChangeType(type) {
                this.formData.type = type.name;
                this.formData.personal = type.personal;
            },
            saveClick(formData) {
                this.formData.projectId = this.project_Id;

                this.$refs[formData].validate((valid) => {
                    if (valid) {
                        if (!this.projectRoomId) {
                            this.$axios.post("/ProjectRoom/", this.formData).then((res) => {
                                if (res.data.hasError == false) {
                                    this.$message.success("保存成功！");
                                    this.$refs[formData].resetFields();
                                    this.goBack();
                                } else {

                                  this.$message.error(res.data.message);                                }
                            });
                        } else {
                            this.$axios
                                .put("/ProjectRoom/" + this.projectRoomId, this.formData)
                                .then((res) => {
                                    if (res.data.hasError == false) {
                                        this.$message.success("编辑成功！");
                                        this.$refs[formData].resetFields();
                                        this.goBack();
                                    } else {

                                      this.$message.error(res.data.message);                                    }
                                });
                        }
                    } else {
                        return false;
                    }
                });
            },
            goBack() {
                this.projectRoomId = "";
                this.admin = "";
                this.editImg = "";
                this.editImg1 = "";
                this.$emit("backFunStu");
                this.$refs["formData"].resetFields();
            },
        }
    };
</script>

<style lang="scss">
    .container {
        margin-bottom: 10px;
    }

    .el-inpt-phone {
        width: calc(100% - 70px);
    }

    .jc-btn {
        position: absolute;
        width: 60px;
        right: 0;
    }
</style>